import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { Subscription } from 'rxjs';
import { AuthService, encryptStorage } from '../auth/auth.service';
import { OrdersSearch } from '../models/orders';
import { OrdersService } from '../orders/orders.service';
import { emptyFields } from '../utilities/common-file';
import { CommonService } from '../utilities/common-service';
import { NzTableData } from '../utilities/nz-table.adapter';

@Component({
  selector: 'app-view-orders',
  templateUrl: './view-orders.component.html'
})
export class ViewOrdersComponent implements OnInit {
  private tableData: NzTableData<OrdersSearch, any> = new NzTableData <OrdersSearch, any>(new OrdersSearch(), 'name');
  @Input() selectedOrders:any;
  loading: boolean;
  subscription: Subscription;
  // For drawer Close when refresh custom token fails
  notifyLogout: any;
  emptyField = emptyFields;
  selectedOrder: any;
  currencySymbol='';
  data:any;
 showAppCodeFilter= false;

  
  
  constructor(private modal: NzModalService, private drawerService: NzDrawerService, private notification: NzNotificationService, private ordersService: OrdersService, private authService: AuthService,private commonService:CommonService, private router:Router, private drawerRef: NzDrawerRef) {
  
  }
  
  ngOnInit() {
  this.data = this.selectedOrders;
   this.tableData.data = this.selectedOrders.merchantOrderDetails;
  this.currencySymbol = encryptStorage.getItem('currencySymbol');


    // this.refresh();
    
  }
  getStatus(status) {
    return this.commonService.getOrderStatus(status);
  }
  // For User Status Tag color
  getStatusColor(status) {
    return this.commonService.getOrderStatusColor(status);
  }
  
close() {
  this.drawerRef.close();
}
  getDeliveryMethod(row){
    return this.commonService.getDeliveryMethod(row);
  }
  getDeliveryAddress(row){ 
    
  let data = JSON.parse(row)
  // console.log(JSON.parse(data));
  let obj = JSON.parse(data)
  return (
    (obj.displayName? obj.displayName + ', ':"") + 
    (obj.mobileNo ? '+' + obj.countryCode + ' ' + obj.mobileNo + ', ':"") 
    + obj.country + ', ' + obj.state + ', ' + obj.city + ', ' + obj.street)
  // return data.replace(/[{}]/g, '');
  }
}
